import { useContext } from 'react'
import { RemoteAssistanceTestSpeedContext } from 'context/remoteAssistance'

const useRemoteAssistanceTestSpeed = () => {
  return useContext(RemoteAssistanceTestSpeedContext)
}

export default useRemoteAssistanceTestSpeed
